// creating wrapper around builder io fetching entries. Should make a mock adapter too
import {
    fetchOneEntry,
    fetchEntries,
    isPreviewing,
    getBuilderSearchParams
} from "@builder.io/sdk-vue";
class BuilderApi {
    adapter: BuilderAdapter;
    apiKey: string;
    constructor(adapter: string, apiKey: string) {
        this.adapter = this.adapters[adapter];
        this.apiKey = apiKey;
    }

    get adapters() {
        return {
            mock: new MockBuilderAdapter(),
            builder: new BuilderAdapter()
        };
    }

    fetchOneEntry(props) {
        if (props.apiKey === undefined) props.apiKey = this.apiKey;
        return this.adapter.fetchOneEntry(props);
    }

    fetchEntries(props) {
        if(props.options === undefined) props.options = {};
        if (props.apiKey === undefined) props.apiKey = this.apiKey;
        if (props.query != null){
            props.options = {
                ...props.options,
                ...getBuilderSearchParams(props.query)
            };
        }
        return this.adapter.fetchEntries(props);
    }

    isPreviewing() {
        return this.adapter.isPreviewing();
    }
}

interface BuilderAdapter {
    fetchOneEntry(props: any);
    fetchEntries(props: any);
    isPreviewing(): boolean;
}

class BuilderAdapter implements BuilderAdapter {
    fetchOneEntry(props) {
        return fetchOneEntry(props);
    }

    fetchEntries(props) {
        return fetchEntries(props);
    }

    isPreviewing() {
        return isPreviewing();
    }
}

class MockBuilderAdapter implements BuilderAdapter {
    fetchOneEntry(props) {
        return new Promise((resolve, reject) => {
            resolve({
                data: {
                    ...props
                }
            });
        });
    }

    fetchEntries(props) {
        return new Promise((resolve, reject) => {
            resolve([]);
        });
    }

    isPreviewing() {
        return false;
    }
}

export default BuilderApi;
